module.exports = __webpack_public_path__ + "img/img-84.0b73325f.png";